import { render, staticRenderFns } from "./NewMarquee.vue?vue&type=template&id=343f9b1a&scoped=true"
import script from "./NewMarquee.vue?vue&type=script&lang=js"
export * from "./NewMarquee.vue?vue&type=script&lang=js"
import style0 from "./NewMarquee.vue?vue&type=style&index=0&id=343f9b1a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343f9b1a",
  null
  
)

export default component.exports